import ActionTypes from '../../actionTypes';
/**
 * Action creator for deriving the news groups.
 * Used when the call to fetch newspapers is made.
 */
var deriveNewsGroups = function (newsGroups) { return ({
    type: ActionTypes.DERIVE_NEWSGROUPS,
    payload: newsGroups,
}); };
export default deriveNewsGroups;
